/** Chart theming. Hex rather than classes: Recharts paints SVG, not DOM. */

import { ScoreBand } from "./scoring";

/**
 * Plot height for the charts and for the placeholder that stands in while their
 * data is in flight, so the card cannot change height when one replaces the other.
 */
export const EVAL_CHART_HEIGHT_CLS = "h-[220px]";

/**
 * The trend's single series. Canvas cannot read a CSS custom property, so both
 * steps are inlined here and picked by `useIsDarkMode`; they are the resolved
 * values of `--blue-500` in each mode, both clear of the 3:1 floor for a mark.
 */
export const TREND_LINE_COLOR = {
  light: "#0069e0",
  dark: "#3486e5",
} as const;

/** Hairline grid, one step off the surface in each mode. */
export const TREND_GRID_COLOR = {
  light: "#e0e0e0",
  dark: "#333333",
} as const;

export const TREND_AXIS_TEXT_COLOR = {
  light: "#767676",
  dark: "#bdbdbd",
} as const;

/**
 * The score band fills again, as literal hex for canvas. Duplicated rather than
 * derived because chart.js cannot resolve a CSS custom property and the
 * `--color-*` tokens are `@theme inline`, so they emit no runtime value. Keep in
 * step with the `cellClass` steps above.
 */
export const SCORE_BAND_HEX = {
  light: {
    [ScoreBand.CORRECT]: "#cdeee0",
    [ScoreBand.MOSTLY_CORRECT]: "#67cba0",
    [ScoreBand.MOSTLY_INCORRECT]: "#d76582",
    [ScoreBand.INCORRECT]: "#bd002f",
  },
  dark: {
    [ScoreBand.CORRECT]: "#004226",
    [ScoreBand.MOSTLY_CORRECT]: "#32b87e",
    [ScoreBand.MOSTLY_INCORRECT]: "#cc3359",
    [ScoreBand.INCORRECT]: "#f1cad3",
  },
} as const satisfies Record<"light" | "dark", Record<ScoreBand, string>>;

/**
 * The spread, drawn as a wash of the trend's own hue. One hue and not a trace per
 * agent: green and red are spoken for by the score ramp, and the remaining
 * non-status hues do not survive an all-pairs CVD check against each other, so
 * the agent facet narrows the series instead.
 */
export const TREND_SPREAD_FILL = {
  light: "#0069e01a",
  dark: "#3486e51a",
} as const;
